"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrder = void 0;
class GetOrder {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getOrder(request);
    }
}
exports.GetOrder = GetOrder;
